import {
  Document,
  Packer,
  Paragraph,
  TextRun,
  HeadingLevel,
  AlignmentType,
} from 'docx';
import { saveAs } from 'file-saver';

const heading = (text) =>
  new Paragraph({
    text,
    heading: HeadingLevel.HEADING_2,
    spacing: { before: 280, after: 140 },
  });

const bodyText = (text) =>
  new Paragraph({
    children: [new TextRun({ text: text || 'N/A', size: 22 })],
    spacing: { after: 200 },
  });

export const generateAndDownloadPlanOfAttackDocx = async ({
  activity,
  universitySubject,
  planText,
}) => {
  if (!activity) return;

  const doc = new Document({
    sections: [
      {
        properties: {},
        children: [
          new Paragraph({
            text: activity.activity_title || 'Super Curricular Activity',
            heading: HeadingLevel.HEADING_1,
            alignment: AlignmentType.CENTER,
            spacing: { after: 120 },
          }),
          new Paragraph({
            children: [
              new TextRun({
                text: `${activity.category || ''}${
                  universitySubject ? `  •  ${universitySubject}` : ''
                }`,
                italics: true,
                color: '028BE8',
              }),
            ],
            alignment: AlignmentType.CENTER,
            spacing: { after: 360 },
          }),

          heading('Activity Details'),
          bodyText(activity.activity_details),

          heading('Impact'),
          bodyText(activity.impact),

          heading('How to Achieve'),
          bodyText(activity.how_to_achieve),

          heading('My Plan of Attack'),
          bodyText(planText),
        ],
      },
    ],
  });

  const blob = await Packer.toBlob(doc);
  const safeTitle = (activity.activity_title || 'plan-of-attack')
    .replace(/[^a-z0-9]+/gi, '-')
    .toLowerCase();
  saveAs(blob, `${safeTitle}-plan.docx`);
};